import { Switch, Route } from 'react-router-dom';

import { quizRoutes } from 'types/quiz';

import QuizQuestions from './components/QuizQuestions/QuizQuestions';
import QuizStarter from './components/QuizStarter/QuizStarter';
import QuizResult from './components/QuizResult/QuizResult';

import './Quiz.scoped.scss';

const Quiz: React.FC = () => {
  return (
    <div className="quiz-container">
      <Switch>
        <Route path={quizRoutes.defaultPath} exact component={QuizStarter} />
        <Route path={quizRoutes.questionQuizPath} exact component={QuizQuestions} />
        <Route path={quizRoutes.resultQuizPath} exact component={QuizResult} />

        <Route path={quizRoutes.studyDefaultPath} exact component={QuizStarter} />
        <Route path={quizRoutes.studyQuestionQuizPath} exact component={QuizQuestions} />
        <Route path={quizRoutes.studyResultQuizPath} exact component={QuizResult} />
      </Switch>
    </div>
  );
};

export default Quiz;
